module.exports = __webpack_public_path__ + "img/CCS2.2b9b38c9.svg";